module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "textcenter"
  }, [_c('a', {
    attrs: {
      "id": "ch00_fm02_dedic"
    }
  }), _c('a', {
    attrs: {
      "id": "page_iii"
    }
  }), _c('em', [_vm._v("The American Social Experience")])]), _vm._v(" "), _c('p', {
    staticClass: "textcenter"
  }, [_vm._v("SERIES")]), _vm._v(" "), _c('p', {
    staticClass: "textcenter11"
  }, [_c('em', [_vm._v("James Kirby Martin")])]), _vm._v(" "), _c('p', {
    staticClass: "textcenter"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("GENERAL EDITOR")])]), _vm._v(" "), _c('p', {
    staticClass: "textcenter1"
  }, [_c('em', [_vm._v("Paula S. Fass, Steven H. Mintz, Carl Prince, James W. Reed & Peter N. Stearns")])]), _vm._v(" "), _c('p', {
    staticClass: "textcenter"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("EDITORS")])]), _vm._v(" "), _c('p', {
    staticClass: "textcenter1"
  }, [_c('em', [_vm._v("1. The March to the Sea and Beyond:"), _c('br'), _vm._v("Sherman’s Troops in the Savannah and"), _c('br'), _vm._v("Carolinas Campaigns")]), _c('br'), _c('span', {
    staticClass: "small"
  }, [_vm._v("JOSEPH T. GLATTHAAR")])]), _vm._v(" "), _c('p', {
    staticClass: "textcenter11"
  }, [_c('em', [_vm._v("2. Childbearing in American Society:"), _c('br'), _vm._v("1650–1850")]), _c('br'), _c('span', {
    staticClass: "small"
  }, [_vm._v("CATHERINE M. SCHOLTEN")])]), _vm._v(" "), _c('p', {
    staticClass: "textcenter11"
  }, [_c('em', [_vm._v("3. The Origins of Behaviorism:"), _c('br'), _vm._v("American Psychology, 1870–1920")]), _c('br'), _c('span', {
    staticClass: "small"
  }, [_vm._v("JOHN M. O’DONNELL")])]), _vm._v(" "), _c('p', {
    staticClass: "textcenter11"
  }, [_c('em', [_vm._v("4. New York City Cartmen, 1667–1850")]), _c('br'), _c('span', {
    staticClass: "small"
  }, [_vm._v("GRAHAM RUSSELL HODGES")])]), _vm._v(" "), _c('p', {
    staticClass: "textcenter11"
  }, [_c('em', [_vm._v("5. From Equal Suffrage to Equal Rights:"), _c('br'), _vm._v("Alice Paul and the"), _c('br'), _vm._v("National Woman’s Party, 1910–1928")]), _c('br'), _c('span', {
    staticClass: "small"
  }, [_vm._v("CHRISTINE A. LUNARDINI")])]), _vm._v(" "), _c('p', {
    staticClass: "textcenter11"
  }, [_c('em', [_vm._v("6. Mr. Jefferson’s Army:"), _c('br'), _vm._v("Political and Social Reform of the"), _c('br'), _vm._v("Military Establishment, 1801–1809")]), _c('br'), _c('span', {
    staticClass: "small"
  }, [_vm._v("THEODORE J. CRACKEL")])]), _vm._v(" "), _c('p', {
    staticClass: "textcenter11"
  }, [_c('em', [_vm._v("7. “A Peculiar People”:"), _c('br'), _vm._v("Slave Religion and Community-Culture"), _c('br'), _vm._v("among the Gullahs")]), _c('br'), _c('span', {
    staticClass: "small"
  }, [_vm._v("MARGARET WASHINGTON CREEL")])]), _vm._v(" "), _c('p', {
    staticClass: "textcenter11"
  }, [_c('em', [_vm._v("8. “A Mixed Multitude”: The Struggle"), _c('br'), _vm._v("for Toleration in Colonial Pennsylvania")]), _c('br'), _c('span', {
    staticClass: "small"
  }, [_vm._v("SALLY SCHWARTZ")])]), _vm._v(" "), _c('p', {
    staticClass: "textcenter11"
  }, [_c('em', [_vm._v("9. Women, Work, and Fertility,"), _c('br'), _vm._v("1900–1986")]), _c('br'), _c('span', {
    staticClass: "small"
  }, [_vm._v("SUSAN HOUSEHOLDER VAN HORN")])]), _vm._v(" "), _c('p', {
    staticClass: "textcenter11"
  }, [_c('em', [_vm._v("10. Liberty, Virtue, and Progress:"), _c('br'), _vm._v("Northerners and Their War"), _c('br'), _vm._v("for the Union")]), _c('br'), _c('span', {
    staticClass: "small"
  }, [_vm._v("EARL J. HESS")])]), _vm._v(" "), _c('p', {
    staticClass: "textcenter11"
  }, [_c('em', [_vm._v("11. Lewis M. Terman:"), _c('br'), _vm._v("Pioneer in Psychological Testing")]), _c('br'), _c('span', {
    staticClass: "small"
  }, [_vm._v("HENRY L. MINTON")])]), _vm._v(" "), _c('p', {
    staticClass: "textcenter11"
  }, [_c('em', [_vm._v("12. Schools as Sorters: Lewis M. Terman,"), _c('br'), _vm._v("Applied Psychology, and the Intelligence"), _c('br'), _vm._v("Testing Movement, 1890–1930")]), _c('br'), _c('span', {
    staticClass: "small"
  }, [_vm._v("PAUL DAVIS CHAPMAN")])]), _vm._v(" "), _c('p', {
    staticClass: "textcenter11"
  }, [_c('em', [_vm._v("13. Free Love:"), _c('br'), _vm._v("Marriage and Middle-Class Radicalism"), _c('br'), _vm._v("in America, 1825–1860")]), _c('br'), _c('span', {
    staticClass: "small"
  }, [_vm._v("JOHN C. SPURLOCK")])]), _vm._v(" "), _c('p', {
    staticClass: "textcenter11"
  }, [_c('em', [_vm._v("14. Jealousy: The Evolution of an"), _c('br'), _vm._v("Emotion in American History")]), _c('br'), _c('span', {
    staticClass: "small"
  }, [_vm._v("PETER N. STEARNS")])]), _vm._v(" "), _c('p', {
    staticClass: "textcenter11"
  }, [_c('em', [_vm._v("15. The Nurturing Neighborhood:"), _c('br'), _vm._v("The Brownsville Boys Club and"), _c('br'), _vm._v("Jewish Community in Urban America,"), _c('br'), _vm._v("1940–1990")]), _c('br'), _c('span', {
    staticClass: "small"
  }, [_vm._v("GERALD SORIN")])]), _vm._v(" "), _c('p', {
    staticClass: "textcenter11"
  }, [_c('em', [_vm._v("16. War in America to 1775:"), _c('br'), _vm._v("Before Yankee Doodle")]), _c('br'), _c('span', {
    staticClass: "small"
  }, [_vm._v("JOHN MORGAN DEDERER")])]), _vm._v(" "), _c('p', {
    staticClass: "textcenter11"
  }, [_c('em', [_vm._v("17. An American Vision:"), _c('br'), _vm._v("Far Western Landscape and"), _c('br'), _vm._v("National Culture, 1820–1920")]), _c('br'), _c('span', {
    staticClass: "small"
  }, [_vm._v("ANNE FARRAR HYDE")])]), _vm._v(" "), _c('p', {
    staticClass: "textcenter11"
  }, [_c('a', {
    attrs: {
      "id": "page_iv"
    }
  }), _c('em', [_vm._v("18. Frederick Law Olmsted:"), _c('br'), _vm._v("The Passion of a Public Artist")]), _c('br'), _c('span', {
    staticClass: "small"
  }, [_vm._v("MELVIN KALFUS")])]), _vm._v(" "), _c('p', {
    staticClass: "textcenter11"
  }, [_c('em', [_vm._v("19. Medical Malpractice in Nineteenth-"), _c('br'), _vm._v("Century America: Origins and Legacy")]), _c('br'), _c('span', {
    staticClass: "small"
  }, [_vm._v("KENNETH ALLEN DE VILLE")])]), _vm._v(" "), _c('p', {
    staticClass: "textcenter11"
  }, [_c('em', [_vm._v("20. Dancing in Chains: The Youth of"), _c('br'), _vm._v("William Dean Howells")]), _c('br'), _c('span', {
    staticClass: "small"
  }, [_vm._v("RODNEY D. OLSEN")])]), _vm._v(" "), _c('p', {
    staticClass: "textcenter11"
  }, [_c('em', [_vm._v("21. Breaking the Bonds: Marital Discord"), _c('br'), _vm._v("in Pennsylvania, 1730–1830")]), _c('br'), _c('span', {
    staticClass: "small"
  }, [_vm._v("MERRIL D. SMITH")])]), _vm._v(" "), _c('p', {
    staticClass: "textcenter11"
  }, [_c('em', [_vm._v("22. In the Web of Class: Delinquents and"), _c('br'), _vm._v("Reformers in Boston, 1810s–1930s")]), _c('br'), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERIC C. SCHNEIDER")])]), _vm._v(" "), _c('p', {
    staticClass: "textcenter11"
  }, [_c('em', [_vm._v("23. Army of Manifest Destiny:"), _c('br'), _vm._v("The American Soldier"), _c('br'), _vm._v("in the Mexican War, 1846–1848")]), _c('br'), _c('span', {
    staticClass: "small"
  }, [_vm._v("JAMES M. MCCAFFREY")])]), _vm._v(" "), _c('p', {
    staticClass: "textcenter11"
  }, [_c('em', [_vm._v("24. The Dutch-American Farm")]), _c('br'), _c('span', {
    staticClass: "small"
  }, [_vm._v("DAVID STEVEN COHEN")])]), _vm._v(" "), _c('p', {
    staticClass: "textcenter11"
  }, [_c('em', [_vm._v("25. Independent Intellectuals in the"), _c('br'), _vm._v("United States, 1910–1945")]), _c('br'), _c('span', {
    staticClass: "small"
  }, [_vm._v("STEVEN BIEL")])]), _vm._v(" "), _c('p', {
    staticClass: "textcenter11"
  }, [_c('em', [_vm._v("26. The Modern Christmas in America:"), _c('br'), _vm._v("A Cultural History of Gift Giving")]), _c('br'), _c('span', {
    staticClass: "small"
  }, [_vm._v("WILLIAM B. WAITS")])]), _vm._v(" "), _c('p', {
    staticClass: "textcenter11"
  }, [_c('em', [_vm._v("27. The First Sexual Revolution:"), _c('br'), _vm._v("The Emergence of Male Heterosexuality"), _c('br'), _vm._v("in Modern America")]), _c('br'), _c('span', {
    staticClass: "small"
  }, [_vm._v("KEVIN WHITE")])]), _vm._v(" "), _c('p', {
    staticClass: "textcenter11"
  }, [_c('em', [_vm._v("28. Bad Habits:"), _c('br'), _vm._v("Drinking, Smoking, Taking Drugs,"), _c('br'), _vm._v("Gambling, Sexual Misbehavior, and"), _c('br'), _vm._v("Swearing in American History")]), _c('br'), _c('span', {
    staticClass: "small"
  }, [_vm._v("JOHN C. BURNHAM")])]), _vm._v(" "), _c('p', {
    staticClass: "textcenter11"
  }, [_c('em', [_vm._v("29. General Richard Montgomery and"), _c('br'), _vm._v("the American Revolution:"), _c('br'), _vm._v("From Redcoat to Rebel")]), _c('br'), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAL T. SHELTON")])]), _vm._v(" "), _c('p', {
    staticClass: "textcenter11"
  }, [_c('em', [_vm._v("30. From Congregation Town to"), _c('br'), _vm._v("Industrial City: Culture and Social"), _c('br'), _vm._v("Change in a Southern Community")]), _c('br'), _c('span', {
    staticClass: "small"
  }, [_vm._v("MICHAEL SHIRLEY")])]), _vm._v(" "), _c('p', {
    staticClass: "textcenter11"
  }, [_c('em', [_vm._v("31. The Social Anxieties of Progressive"), _c('br'), _vm._v("Reform: Atlantic City, 1854–1920")]), _c('br'), _c('span', {
    staticClass: "small"
  }, [_vm._v("MARTIN PAULSSON")])]), _vm._v(" "), _c('p', {
    staticClass: "textcenter11"
  }, [_c('em', [_vm._v("32. America Goes to War:"), _c('br'), _vm._v("A Social History of the Continental Army")]), _c('br'), _c('span', {
    staticClass: "small"
  }, [_vm._v("CHARLES PATRICK NEIMEYER")])]), _vm._v(" "), _c('p', {
    staticClass: "textcenter11"
  }, [_c('em', [_vm._v("33. American Women and the"), _c('br'), _vm._v("Repeal of Prohibition")]), _c('br'), _c('span', {
    staticClass: "small"
  }, [_vm._v("KENNETH D. ROSE")])]), _vm._v(" "), _c('p', {
    staticClass: "textcenter11"
  }, [_c('em', [_vm._v("34. Making Men Moral:"), _c('br'), _vm._v("Social Engineering during the Great War")]), _c('br'), _c('span', {
    staticClass: "small"
  }, [_vm._v("NANCY K. BRISTOW")])]), _vm._v(" "), _c('p', {
    staticClass: "textcenter11"
  }, [_c('em', [_vm._v("35. Tituba, Reluctant Witch of Salem:"), _c('br'), _vm._v("Devilish Indians and Puritan Fantasies")]), _c('br'), _c('span', {
    staticClass: "small"
  }, [_vm._v("ELAINE G. BRESLAW")])]), _vm._v(" "), _c('p', {
    staticClass: "textcenter11"
  }, [_c('em', [_vm._v("36. Yankee Town, Southern City:"), _c('br'), _vm._v("Race and Class Relations"), _c('br'), _vm._v("in Civil War Lynchburg")]), _c('br'), _c('span', {
    staticClass: "small"
  }, [_vm._v("STEVEN ELLIOTT TRIPP")])]), _vm._v(" "), _c('p', {
    staticClass: "textcenter11"
  }, [_c('em', [_vm._v("37. The End of the"), _c('br'), _vm._v("American Avant Garde")]), _c('br'), _c('span', {
    staticClass: "small"
  }, [_vm._v("STUART D. HOBBS")])]), _vm._v(" "), _c('p', {
    staticClass: "textcenter11"
  }, [_c('em', [_vm._v("38. Thomas Hutchinson and the"), _c('br'), _vm._v("Origins of the American Revolution")]), _c('br'), _c('span', {
    staticClass: "small"
  }, [_vm._v("ANDREW STEPHEN WALMSLEY")])]), _vm._v(" "), _c('p', {
    staticClass: "textcenter11"
  }, [_c('em', [_vm._v("39. Why America Stopped Voting:"), _c('br'), _vm._v("The Decline of Participatory Democracy"), _c('br'), _vm._v("and the Emergence of Modern American"), _c('br'), _vm._v("Politics")]), _c('br'), _c('span', {
    staticClass: "small"
  }, [_vm._v("MARK LAWRENCE KORNBLUH")])]), _vm._v(" "), _c('p', {
    staticClass: "textcenter11"
  }, [_c('em', [_vm._v("40. Shrinking Violets and"), _c('br'), _vm._v("Caspar Milquetoasts:"), _c('br'), _vm._v("Shyness, Power, and Intimacy in the"), _c('br'), _vm._v("United States, 1950–1995")]), _c('br'), _c('span', {
    staticClass: "small"
  }, [_vm._v("PATRICIA A. MCDANIEL")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02256313","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch00_fm02_dedic.vue
// module id = 60
// module chunks = 0